import { render, staticRenderFns } from "./NflOptimizerTable.vue?vue&type=template&id=564e0d37&scoped=true"
import script from "./NflOptimizerTable.vue?vue&type=script&lang=js"
export * from "./NflOptimizerTable.vue?vue&type=script&lang=js"
import style0 from "./NflOptimizerTable.vue?vue&type=style&index=0&id=564e0d37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564e0d37",
  null
  
)

export default component.exports